import { render, staticRenderFns } from "./DriverInfractionsDots.vue?vue&type=template&id=e2252e44&scoped=true&"
import script from "./DriverInfractionsDots.vue?vue&type=script&lang=js&"
export * from "./DriverInfractionsDots.vue?vue&type=script&lang=js&"
import style0 from "./DriverInfractionsDots.vue?vue&type=style&index=0&id=e2252e44&scoped=true&lang=scss&"
import style1 from "./DriverInfractionsDots.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2252e44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSkeletonLoader,VTooltip})
